import React, { Component } from 'react'
import './stylesheets/notification.css'
import HeaderBack from '../../../components/backoffice/headerback/HeaderBack'
import {getBackSiteid,getBackAllCustomer,getBackBranchesById,getBackTechByUserId,addNotification,getBackNotificationList} from '../../../modules/serverCall'
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from 'react-bootstrap-table-next';
import {Button, Dropdown, Offcanvas, Form, FloatingLabel} from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import Multiselect from 'multiselect-react-dropdown';
// import { AudioRecorder } from 'react-audio-voice-recorder';
// import ReactAudioPlayer from 'react-audio-player';

 
export default class Notification extends Component {
  constructor(props) {
    super(props);
    this.wrapper = React.createRef();
    this.state = {
      showData: false,
      scroll: false,
      backdrop: false,
      play:false,
      name:'Job',
      MinFromDate:new Date(),
      MaxFromDate:'',
      MinToDate:new Date(),
      MaxToDate:'',
      placement: 'end',
      notificationFile:'',
      notificationList:[],
      CustomerID:0,
      CustomerName:'',
      urlAudio:'',
      listCustomer:[],
      siteId: 0,
      selectedSite:"Site Id",
      listSiteId:'',
      optionsTech:[],
      optionsBranch:[],
      optionsSite:[],
      errorMsg:'',
      errorMsgData:'',
      // isError:{
      //   CustomerName:''
      // }
    }
    
  }

 componentDidMount () {
    window.scrollTo(0, 0);
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    const userId =  readData.userdata.user_id;
    var sendData = {
        userid:userId,
    }
    this.handleInputFetch();
    const fetchsiteid = async () => {
      // const responsesites = await getBackSiteid(sendData);
      // const datarespsites  = await responsesites;

      // const responseCustomer = await getBackAllCustomer();
      // const datarespCustomer  = await responseCustomer;

      // var siteIdArr = [];
      // for (var i = 0; i < datarespsites.length; i++) {
      //   var siteId={};
      //   siteId.key = datarespsites[i].SiteID;
      //   siteId.value = datarespsites[i].SiteName;
      //   siteIdArr.push(siteId);
      // }
      // var customerListArr = [];
      // for (var i = 0; i < datarespCustomer.length; i++) {
      //   var customerList={};
      //   customerList.value = datarespCustomer[i].CustomerCode;
      //   customerList.label = datarespCustomer[i].CustomerName;
      //   customerListArr.push(customerList);
      // }
      this.setState({
        // listSiteId:siteIdArr,
        // selectedSite:siteIdArr[0].value,
        // siteId:siteIdArr[0].key,
        // listCustomer:customerListArr,
      });
    };
    fetchsiteid();
  }

addAudioElement = (blob) => {
  const urlAudio = URL.createObjectURL(blob);
  // const audio = document.createElement("audio");
  // audio.src = urlAudio;
  // audio.controls = true;
  // document.body.appendChild(audio);
  this.setState({
    urlAudio: urlAudio,
    urlAudioUpload:blob,
  });
};

handleOnChangeTech=(selected) => {
    this.setState({
         techn: selected
     });
 }

 handleOnChangeBranch=(selected) => {
  this.setState({
    branchname: selected
   });
}

handleOnChangeSite=(selected) => {
  this.setState({
       sitenoti: selected
   });
}
  
  handleClose = event => {
    this.setState({ showData: false});
  } 

  handleDataChangeFromDate = event => {
    this.setState({ 
      fromdate: event,
    });
  }

  handleDataChangeToDate = event => {
    this.setState({ 
      todate: event,
    });
  }

  handleDataChangeOther = event => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleDataChangeType = event => {
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    const userId =  readData.userdata.user_id;
    var sendData = {
        userid:userId,
    }
    this.setState({
      selectedOption: event.target.value,
    },() => {
      if(event.target.value === '1'){
        const fetchBranches = async () => {
          const responseBranches = await getBackBranchesById(sendData);
          const datarespBranches  = await responseBranches;

          var branchesListArr = [];
          for (var i = 0; i < datarespBranches.length; i++) {
            var branchesList={};
            branchesList.id = datarespBranches[i].BranchId;
            branchesList.name = datarespBranches[i].BranchName;
            branchesListArr.push(branchesList);
          }
          this.setState({
            optionsBranch: branchesListArr,
          });
        }
        fetchBranches();
        
      }else if(event.target.value === '2'){
        const fetchSiteData = async () => {
          
          const responseSiteData = getBackSiteid(sendData);
          const datarespSiteData  = await responseSiteData;

          var siteDatasListArr = [];
          for (var i = 0; i < datarespSiteData.length; i++) {
            var siteDataList={};
            siteDataList.id = datarespSiteData[i].SiteID;
            siteDataList.name = datarespSiteData[i].SiteName;
            siteDatasListArr.push(siteDataList);
          }
          this.setState({
            optionsSite: siteDatasListArr,
          });
        }
        fetchSiteData();
      }else if(event.target.value === '3'){
        const fetchTechData = async () => {
          
          const responseTechData = getBackTechByUserId(sendData);
          const datarespTechData  = await responseTechData;

          var techDatasListArr = [];
          for (var i = 0; i < datarespTechData.length; i++) {
            var techDataList={};
            techDataList.id = datarespTechData[i].TechnicianId;
            techDataList.name = datarespTechData[i].Name;
            techDatasListArr.push(techDataList);
          }
          this.setState({
            optionsTech: techDatasListArr,
          });
        }
        fetchTechData();
      }
    })
  }

  handleDataChangeDrop = event => {
    this.setState({
      CustomerName: event,
    });
  }
  handleShow = (event,row) => {

    this.setState({ showData: true,customer:event});
  }

handleDropdownSite = (key, event)=>{
    this.setState({ selectedSite:event.target.innerHTML,siteId:key,customerdetails:[],showData: false});
}

  handleInputFetch = event => {
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    const userId =  readData.userdata.user_id;
    var loadingData ='No data Found'
    this.setState({
      loading:true,
      loadingData:'Loading',
    });
    var sendData = {
      userId:userId,
    }

    const fetchNotificationList = async () => {
      const responseUser = await getBackNotificationList(sendData);
      const datarespUser  = await responseUser;
      if(datarespUser.length > 0){
      }else{
          loadingData = "No data found";
      }
      this.setState({
        notificationList:datarespUser,
        loading:false,
        loadingData:loadingData
      });
    };
    fetchNotificationList();
  }

  handleAddNotification = event => {
    var errorMsg ='';
    var Flag = '';
    var NotificationIDs = [];
    event.preventDefault();
    if(this.state.selectedOption === '1'){
      NotificationIDs = this.state.branchname;
      if(this.state.branchname !=='' && this.state.branchname !== undefined && this.state.branchname !== null){
        errorMsg = '';
      }else{
        errorMsg = 'Please select branch';
      }
      
      Flag = 'b';
    }else if(this.state.selectedOption === '2'){
      NotificationIDs = this.state.sitenoti;
      if(this.state.sitenoti !=='' && this.state.sitenoti !== undefined && this.state.sitenoti !== null){
        errorMsg = '';
      }else{
        errorMsg = 'Please select site';
      }
      Flag = 's';
    }else if(this.state.selectedOption === '3'){
      NotificationIDs = this.state.techn;
      if(this.state.techn !=='' && this.state.techn !== undefined && this.state.techn !== null){
        errorMsg = '';
      }else{
        errorMsg = 'Please select technician';
      }
      Flag = 't';
    }

    if(this.state.fromdate.getTime() <= this.state.todate.getTime()){
      this.setState({ 
        errorMsgData:'',
      });
      if(errorMsg === ''){
        const accesstokendata =  localStorage.getItem('access_token');
        const readData = JSON.parse(accesstokendata);
        const userId =  readData.userdata.user_id;
        var  idData = [];
        for (let index = 0; index < NotificationIDs.length; index++) {
          const element = {};
          element.NotificationTypeID = NotificationIDs[index].id;
          idData.push(element);
        }
        
          var submitData = {
            NotificationMessage: this.state.Message,
            DisplayToDate:Moment(this.state.todate).format('YYYY-MM-DD'),
            DisplayFromDate:Moment(this.state.fromdate).format('YYYY-MM-DD'),
            ModifiedBy: userId,
            NotificationIDs: idData,
            Flag: Flag,
          }
          // console.log('submitData',submitData);
          // return false;
          const NotificationAdd = async () => {
            const responsesites = await addNotification(submitData);
            this.setState({ 
              showData: false,
              todate:'',
              fromdate:'',
              Message:'',
              selectedOption:'',
              branchname:'',
              sitenoti:'',
              techn:'',
              errorMsg:'',
              errorMsgData:'',
            });
            this.handleInputFetch();
            
          };
          NotificationAdd();
      }else{
         this.setState({errorMsg : errorMsg});
        return false;
      }
    }else{
        var errorMsgData ='Display till date can not be less than display on date';
         this.setState({errorMsgData : errorMsgData});
        return false;
    }
  }

  handleChangeImage = event => {
    const MySwal = withReactContent(Swal);
    var checkImageData = event.target.files[0];
    
    // var uploadDetailsArr = this.state.uploadDetailsArr;
    // const filteredData = uploadDetailsArr.filter(obj => {
    //   return obj.SelectionType === 110;
    // });
    
    if(event.target.files[0] !== '' && event.target.files[0] !== null && event.target.files[0] !== undefined){
      // if(filteredData.length > 0){
      //   var fileName = event.target.files[0].name;
      //   var patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
      //   var fileExtension = (fileName).match(patternFileExtension);
      //   const MIN_FILE_SIZE = filteredData[0].MaxAllowedSize * 1024;
      //   const fileSizeKiloBytes = checkImageData.size / 1024;
      //   const uploadedFileType =  checkImageData.type;
      //   const fileType = filteredData[0].AllowedFileExtensions;
      //   const fileTypeArray = fileType.split(",");
      //   const filteredFileType = fileTypeArray.find(element => element === fileExtension[0]  || element.toUpperCase() === fileExtension[0]);
      //   if(filteredFileType !==undefined && filteredFileType !==null && filteredFileType !==''){
      //     if(fileSizeKiloBytes < MIN_FILE_SIZE){
            this.setState({
              notificationFile : URL.createObjectURL(event.target.files[0]),
              imageDataUpload:event.target.files[0],
            });
      //     }else{
      //       var msg = "Maximum file size allowed "+filteredData[0].MaxAllowedSize+'MB';
      //       MySwal.fire(msg);
      //     }
      //   }else{
      //     var msg = "File type not allowed";
      //     MySwal.fire(msg);
      //   }
      // }
    }
  }

  togglePlay = () => {
    this.setState({ play: !this.state.play }, () => {
      this.state.play ? this.audio.play() : this.audio.pause();
    });
  }

  render() {
    const options = this.state.listCustomer;
    if(this.state.urlAudio !== ''){
      var audio = new Audio(this.state.urlAudio)
    }
    
    const addUserLogo = require('../../../assets/images/notification.png');
    const terminationLogo = require('../../../assets/images/termination.png');
    var uploadFile =require('../../../assets/images/upload.png');
    if(this.state.notificationFile !=='' && this.state.notificationFile !==null && this.state.notificationFile !==undefined){
      uploadFile = this.state.notificationFile;
     }
    var listSiteId = this.state.listSiteId;
    const columns = [{
      dataField: 'NotificationID',
      text: 'Notification Id',
      headerClasses:'notiidHeader',
      sort: true,
    },{
        dataField: 'Notification',
        text: 'Message',
        headerClasses:'messageHeader',
        filter: textFilter({className: 'filter_class_notiMsg'}),
        sort: true,
      }, {
        dataField: 'DisplayFromDate',
        text: 'Display On',
        headerClasses:'fromdHeader',
        sort: true,
      }
      , {
        dataField: 'DisplayToDate',
        text: 'Display Till',
        headerClasses:'toHeader',
        sort: true,
      },{
        dataField: 'BranchName',
        text: 'Branch',
        headerClasses:'branchHeader',
        filter: textFilter({className: 'filter_class_noti'}),
      }, {
        dataField: 'SiteName',
        text: 'Site',
        headerClasses:'siteHeader',
        filter: textFilter({className: 'filter_class_noti'}),
      }, {
        dataField: 'DisplayName',
        text: 'Technician',
        headerClasses:'technicianHeader',
        filter: textFilter({className: 'filter_class_noti'}),
      }];
      var products = this.state.notificationList;
      var optionsArrayTech = this.state.optionsTech;
      var optionsArrayBranch = this.state.optionsBranch;
      var optionsArraySite =this.state.optionsSite;
    return (
      <div>
        <HeaderBack/>
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-user">
          {/* <div className="filterbtnsite">
            <Dropdown onSelect={this.handleDropdownSite}>
              <Dropdown.Toggle variant="warning" className="font_size" id="dropdown-basic">
                {this.state.selectedSite}
              </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ''?
                  listSiteId.map((item, indexdata) => {
                  return (
                    <Dropdown.Item className="font_size" key={indexdata} eventKey={item.key}>
                      {item.value}
                    </Dropdown.Item>
                  );
                })
                : ''}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Button variant="primary" className="font_size" onClick={this.handleInputFetch}>Fetch</Button>
            </div> */}
            
          </div>
          <div className="submiteditbtnnoti">
            <img src={addUserLogo}
                             alt="logo" className="logo-add-noti" title='Add Notification'  onClick={() => {this.handleShow('Add Notification')}}/>
            </div>
        </div>
        <div className="table-container-user">
        <BootstrapTable
            classes="tabledata-user"
            keyField="JobID"
            id="tabledata"
            data={ products }
            columns={ columns }
            filter={ filterFactory({className: 'custom_filter_class'}) }
            noDataIndication="No data found"
          />
        </div>
        <Offcanvas className="notioff" show={this.state.showData} scroll={this.state.scroll} name={this.state.name} backdrop={this.state.backdrop} placement={this.state.placement} onHide={this.handleClose}>
            <Offcanvas.Header className="popup_header" closeButton>
              <Offcanvas.Title className="header_title"><span className="title_contant">{this.state.customer}</span></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="container">
                  <div className="rowUser justify-content-center">
                    <div className="col-md-12">
                      <form className="pr-5 mb-5 formUser" method="POST" onSubmit={this.handleAddNotification}>
                        <div className="rowUser">
                          
                            <div className="col-md-4 form-group input-data">
                              <Form.Check 
                                type="radio"
                                id="custom-switch"
                                className='font_size'
                                name="type"
                                label="Branch"
                                value="1"
                                required
                                checked={this.state.selectedOption  === '1' ? true : false}
                                onClick={this.handleDataChangeType}
                              />
                            </div>
                            <div className="col-md-4 form-group input-data">
                              <Form.Check 
                                type="radio"
                                id="custom-switch-1"
                                className='font_size'
                                name="type"
                                label="Site"
                                value="2"
                                required
                                checked={this.state.selectedOption  === '2' ? true : false}
                                onClick={this.handleDataChangeType}
                              />
                            </div>
                            <div className="col-md-4 form-group input-data">
                              <Form.Check 
                                type="radio"
                                name="type"
                                className='font_size'
                                id="custom-switch-2"
                                label="Technician"
                                value="3"
                                required
                                checked={this.state.selectedOption  === '3' ? true : false}
                                onClick={this.handleDataChangeType}
                              />
                            </div>
                        </div>
                        <div className="rowUser">
                            <div className="col-md-12 input-noti">
                              <FloatingLabel className="mb-3">
                                {this.state.selectedOption === '1' ?
                                  <Multiselect
                                    required
                                    options={optionsArrayBranch} 
                                    selectedValues={this.state.branchname}
                                    onSelect={this.handleOnChangeBranch}
                                    onRemove={this.handleOnChangeBranch}
                                    displayValue="name"
                                    placeholder="Branch *"
                                    showCheckbox={true}
                                    className="edit_job border-remove noti-multi"
                                  />
                                  :""
                                }
                                {this.state.selectedOption === '2' ?
                                  <Multiselect
                                    required
                                    options={optionsArraySite} 
                                    selectedValues={this.state.sitenoti}
                                    onSelect={this.handleOnChangeSite}
                                    onRemove={this.handleOnChangeSite}
                                    displayValue="name"
                                    placeholder="Sites *"
                                    showCheckbox={true}
                                    className="edit_job border-remove noti-multi"
                                  />
                                  :""
                                }
                                {this.state.selectedOption === '3' ?
                                  <Multiselect
                                    required
                                    options={optionsArrayTech} 
                                    selectedValues={this.state.techn}
                                    onSelect={this.handleOnChangeTech}
                                    onRemove={this.handleOnChangeTech}
                                    displayValue="name"
                                    placeholder="Technician(s) *"
                                    showCheckbox={true}
                                    className="edit_job border-remove noti-multi"
                                  />
                                  :""
                                }
                                    
                                  </FloatingLabel>
                                  {this.state.errorMsg !== '' ?
                                    <span className="tool_tip">
                                        {this.state.errorMsg}
                                    </span>
                                    :''
                                  }
                            </div>
                        </div>
                        <div className="rowUser">
                            <div className="col-md-12 form-group input-noti">
                              <FloatingLabel controlId="floatingInputGrid" className="" label="Message *">
                                  <Form.Control type="text" required name="Message" onChange={this.handleDataChangeOther} placeholder="Message" className="add_noti form__field"  value={this.state.EmployeeIdAdd} />
                              </FloatingLabel>
                            </div>
                        </div>
                        {/* <div className="rowUser">
                            <div className="col-md-12 form-group input-noti">
                              <div className="personal-detail-image-file">
                                <div className="file-kyc">
                                  <label className="-label"  htmlFor={"fileid"}>
                                    <span>&nbsp;</span>
                                  </label>
                                  <input id={"fileid"} type="file" onChange={this.handleChangeImage} accept={this.state.IdentityFileType} />
                                  <img src={uploadFile} id="output" className='file-Img' width="200" />
                                  
                                </div>
                              </div>
                            </div>
                        </div>  */}

                        {/* <div className="rowUser">
                            <div className="col-md-12 form-group input-noti">
                              <AudioRecorder 
                                onRecordingComplete={this.addAudioElement} 
                                downloadOnSavePress={false}
                                downloadFileExtension="mp3"
                              />
                            </div>
                            {this.state.urlAudio !== '' ? 
                              <ReactAudioPlayer
                              src={this.state.urlAudio}
                              autoPlay
                              controls
                            />
                            :""}
                            
                        </div> */}
                        <div className="rowUser">
                            <div className="col-md-6 form-group input-noti">
                              <DatePicker
                                    onChange={(date) => this.handleDataChangeFromDate(date)}
                                    selected={this.state.fromdate}
                                    dateFormat="dd-MMM-yyyy"
                                    minDate={this.state.MinFromDate}
                                    maxDate={this.state.MaxFromDate}
                                    className="form-control-data border-remove "
                                    required
                                    placeholderText="Display On *"
                                />
                            </div>
                            <div className="col-md-6 form-group input-noti">
                              <DatePicker
                                    onChange={(date) => this.handleDataChangeToDate(date)}
                                    selected={this.state.todate}
                                    dateFormat="dd-MMM-yyyy"
                                    minDate={this.state.MinToDate}
                                    maxDate={this.state.MaxToDate}
                                    className="form-control-data border-remove "
                                    required
                                    placeholderText="Display Till *"
                                />
                            </div>
                            {this.state.errorMsgData !== '' ?
                              <span className="tool_tip">
                                  {this.state.errorMsgData}
                              </span>
                              :''
                            }
                        </div>
                        <div className="edit_input submitbtn mt-3">
                            <button type="submit" className="btnval btn btn-success font_size">
                                  Submit
                              </button>
                            <button type="button" onClick={this.handleClose} className="btnval btn btn-warning font_size">
                                Discard
                            </button>
                        </div>
                      </form>
                    </div>
                  </div>
              </div>     
                                  
            </Offcanvas.Body>
        </Offcanvas>
      </div>
    )
  }
}





